export default "__VITE_ASSET__BUC_bAXP__"